export enum PLATFORM {
  LINUX = 'linux',
  MACOS = 'macos',
  IOS = 'ios',
  ANDROID = 'android',
  WINDOWS = 'windows',
  BOT = 'bot',
  ASTRA_LINUX = 'astra-linux',
  WEB = 'web',
  NODE_JS = 'node-js',
}
